export const onContinueReadingClick = (
    originUrl: string | undefined,
    homepageUrl: string,
) => {
    return () => window.location.assign(originUrl || homepageUrl)
}

export const onReturnHomeClick = (homepageUrl: string) => {
    return () => window.location.assign(homepageUrl)
}
